export default __webpack_public_path__ + "static/media/mfp01.9e87eeb6.jpg";